import { forwardRef } from 'react';
import MuiPopper, { PopperProps } from '@mui/material/Popper';

/**
 * Empty popperOptions object has to be passed in for unknown reason, otherwise
 * popper does not run onUpdate and the suggestionContainer position isn't recalculated
 */
const EDPopper = forwardRef<HTMLDivElement, PopperProps>((props, ref) => (
  <MuiPopper ref={ref} popperOptions={{}} {...props} />
));

export default EDPopper;
